import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChart2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stacked-bar-chart-2, revenue"><path d="M2.75 19.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 19V11.75H7V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7 19V6.75H10.25V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 19V9.75H17V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17 19V4.75H20.25V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconStackedBarChart2;
